import {
  Form, Space,
  message,
} from 'antd';
import { useEffect, useState } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';

import { getOneAdminUserService, updateAdminUserService } from '../../services/adminUsersService';
import UsersForm from '../../forms/UsersForm';

function EditAdminUser() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { id } = useParams();
  const [errors, setErrors] = useState({});

  const fetchUser = async () => {
    try {
      const response = await getOneAdminUserService(id);
      if (response) {
        form.setFieldsValue(response);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const onFinish = async (values) => {
    try {
      const res = await updateAdminUserService(id, values);
      if (res?.status === 'success') {
        navigate('/admin/users');
        message.success('მონაცემები წარმატებით შეიცვალა');
      }
    } catch (error) {
      if (error?.response?.data?.status === 'fail') {
        setErrors(error?.response?.data?.errors);
      }
    }
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined
        style={{ fontSize: '20px' }}
        onClick={() => navigate('/admin/users')}
      />

      <UsersForm form={form} onFinish={onFinish} errors={errors} />
    </Space>
  );
}

export default EditAdminUser;
